let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Bdxj3")).then(() => parcelRequire('gM86x'));